import { render, staticRenderFns } from "./product-brand-tab.vue?vue&type=template&id=dabc9b9e&scoped=true"
import script from "./product-brand-tab.vue?vue&type=script&lang=js"
export * from "./product-brand-tab.vue?vue&type=script&lang=js"
import style0 from "./product-brand-tab.vue?vue&type=style&index=0&id=dabc9b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabc9b9e",
  null
  
)

export default component.exports